module.exports = __webpack_public_path__ + "img/Blog-Image.8e568326.png";